module.exports = __webpack_public_path__ + "static/media/ic_participants_start.b3a2bb8f.svg";